export default {
  methods: {
    async fetchBookedTariffOptions() {
      await this.$store.dispatch('V2/tariffOptions/fetchTariffOptions')
    },
    isTariffOptionBooked(searchTariffOptionId) {
      return this.$store.getters['V2/tariffOptions/isTariffOptionFound'](searchTariffOptionId)
    }
  }
}
